module.exports = __webpack_public_path__ + "assets/images/3yWtKSzL.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wopi-logo.svg
// module id = 1137
// module chunks = 0